import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { PageSubheaderBarConfig } from './page-config-api';

@Component({
    selector: 'fw-page-subheader-bar',
    template: require('./page-subheader-bar.component.html'),
    styles: [require('./page-subheader-bar.component.css')]
})
export class PageSubheaderBarComponent implements OnInit {
    @Input() config = new PageSubheaderBarConfig();

    @Output() btnClick = new EventEmitter<any>();

    constructor() { }

    ngOnInit() {
    }

    btnClicked(event) {
        this.btnClick.emit(event);
    }
}



// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./Scripts/fw/pages/page-subheader-bar.component.ts